import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Configuring slices
/**
 * SidebarSlice stores collapseHierarchy of currently opened collapsable groups.
 * See **SidebarItem** component to get more.
 */
export const sidebarSlice = createSlice({
    name: "sidebarSlice",
    initialState: {
        collapseHierarchy: [] as number[]
    },
    reducers: {
        collapseGroup: (state, action: PayloadAction<number[]>) => {
            state.collapseHierarchy = action.payload;
        }
    }
});

export const { collapseGroup } = sidebarSlice.actions;